/* header-drawer-swipe-close.js
   iOS-like swipe down (follow finger) to close bottom-sheet mobile drawer
*/
(() => {
  const MOBILE_MQ = window.matchMedia("(max-width: 749px)");
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function getSheetFromTarget(target) {
    const sheet = target.closest?.(".menu-drawer, .menu-drawer__submenu");
    if (!sheet) return null;
    const st = window.getComputedStyle(sheet);
    if (st.visibility === "hidden" || st.opacity === "0") return null;
    return sheet;
  }

  function getCloser(sheet) {
    const headerDrawer = sheet?.closest("header-drawer") || document.querySelector("header-drawer");
    const details =
      headerDrawer?.querySelector("details.menu-drawer-container") ||
      document.querySelector("details.menu-drawer-container");

    return {
      isOpen() {
        return !!details?.open || document.documentElement.classList.contains("menu-open");
      },
      close() {
        if (headerDrawer && typeof headerDrawer.close === "function") {
          headerDrawer.close();
          return;
        }
        if (details) details.open = false;
        document.documentElement.classList.remove("menu-open");
        document.body.classList.remove("overflow-hidden");
      },
    };
  }

  function init() {
    const details = document.querySelector("details.menu-drawer-container");
    if (!details) return;

    let dragging = false;
    let startY = 0;
    let startX = 0;
    let startT = 0;
    let activeSheet = null;
    let backdrop = null;

    function canStartDrag(sheet, target) {
      const { isOpen } = getCloser(sheet);
      if (!isOpen()) return false;

      // iOS feel: trascina solo se sei "in cima" allo scroll del drawer
      if (sheet.scrollTop > 0) return false;

      const tag = target?.tagName?.toLowerCase();
      if (["input", "textarea", "select"].includes(tag)) return false;

      return true;
    }

    function setTranslate(px) {
      if (!activeSheet) return;
      activeSheet.style.transition = "none";
      activeSheet.style.transform = `translateY(${px}px)`;

      if (backdrop) {
        backdrop.style.transition = "none";
        const p = clamp(1 - px / (window.innerHeight * 0.5), 0, 1);
        backdrop.style.opacity = String(p);
      }
    }

    function snapBack() {
      if (!activeSheet) return;
      activeSheet.style.transition = "";
      activeSheet.style.transform = "translateY(0)";
      if (backdrop) {
        backdrop.style.transition = "";
        backdrop.style.opacity = "1";
      }

      const sheetRef = activeSheet;
      sheetRef.addEventListener(
        "transitionend",
        () => {
          sheetRef.style.transform = "";
          if (backdrop) backdrop.style.opacity = "";
        },
        { once: true }
      );
    }

    function endDrag(totalDy) {
      if (!activeSheet) return;

      const dt = Math.max(1, performance.now() - startT);
      const velocity = totalDy / dt; // px/ms

      const CLOSE_DISTANCE = 120;
      const CLOSE_VELOCITY = 0.6;

      if (totalDy > CLOSE_DISTANCE || velocity > CLOSE_VELOCITY) {
        const { close } = getCloser(activeSheet);

        activeSheet.style.transition = "";
        activeSheet.style.transform = `translateY(${window.innerHeight}px)`;
        if (backdrop) {
          backdrop.style.transition = "";
          backdrop.style.opacity = "0";
        }

        setTimeout(() => {
          close();
          // pulizia inline
          if (activeSheet) {
            activeSheet.style.transform = "";
            activeSheet.style.transition = "";
          }
          if (backdrop) {
            backdrop.style.opacity = "";
            backdrop.style.transition = "";
          }
          activeSheet = null;
        }, 120);
      } else {
        snapBack();
        activeSheet = null;
      }
    }

    // TOUCH EVENTS (iOS-safe)
    document.addEventListener(
      "touchstart",
      (e) => {
        if (!MOBILE_MQ.matches) return;
        if (!e.touches || e.touches.length !== 1) return;

        const sheet = getSheetFromTarget(e.target);
        if (!sheet) return;
        if (!canStartDrag(sheet, e.target)) return;

        dragging = true;
        activeSheet = sheet;
        backdrop = document.querySelector(".menu-drawer__backdrop");

        const t = e.touches[0];
        startY = t.clientY;
        startX = t.clientX;
        startT = performance.now();
      },
      { passive: true }
    );

    document.addEventListener(
      "touchmove",
      (e) => {
        if (!dragging || !activeSheet) return;
        if (!e.touches || e.touches.length !== 1) return;

        const t = e.touches[0];
        const dy = t.clientY - startY;
        const dx = t.clientX - startX;

        // se diventa orizzontale, abort
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          dragging = false;
          activeSheet.style.transition = "";
          activeSheet = null;
          return;
        }

        if (dy <= 0) return; // solo verso il basso

        // blocca lo scroll della pagina mentre trascini lo sheet
        e.preventDefault();

        const max = window.innerHeight * 0.8;
        setTranslate(clamp(dy, 0, max));
      },
      { passive: false }
    );

    document.addEventListener(
      "touchend",
      (e) => {
        if (!dragging) return;
        dragging = false;

        // calcolo dy: se touchend non ha touches, uso changedTouches
        const t = e.changedTouches && e.changedTouches[0];
        const endY = t ? t.clientY : startY;
        const totalDy = Math.max(0, endY - startY);

        endDrag(totalDy);
      },
      { passive: true }
    );

    document.addEventListener(
      "touchcancel",
      () => {
        dragging = false;
        if (activeSheet) snapBack();
        activeSheet = null;
      },
      { passive: true }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();